import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "base-select" }
const _hoisted_2 = ["selected", "value"]

import { BaseSelectItem } from "@/types/base-select";
import { PropType } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  selected: {
    type: Object as PropType<BaseSelectItem>,
    default: null,
  },
  options: {
    type: Object as PropType<Array<BaseSelectItem>>,
    default: () => ({}),
  },
},
  emits: ["toggle:select"],
  setup(__props, { emit }) {

const props = __props;




const onChange = (event: any) => {
  const item = props.options.filter((item) => item.id == event.target.value);
  emit("toggle:select", item[0]);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("select", { onChange: onChange }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          selected: item.id == __props.selected.id,
          value: item.id
        }, _toDisplayString(item.name), 9, _hoisted_2))
      }), 128))
    ], 32)
  ]))
}
}

})